module.exports = __webpack_public_path__ + "static/img/historyDataBg.acea5f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/common/historyDataBg.png
// module id = Xir0
// module chunks = 319